import Vue from "vue";
import VueLocalStorage from "vue-localstorage";
import Languages from "../../res/translations";

Vue.use(VueLocalStorage);
const supportedLanguages = Object.getOwnPropertyNames(Languages);

export default {
  namespaced: true,
  state: {
    language: Vue.localStorage.get("language")
  },
  mutations: {
    SET_LANGUAGE(state, lang) {
      Vue.localStorage.set("language", lang);
      state.language = lang;
    }
  },
  actions: {
    setLanguage({ commit }, languages) {
      if (typeof languages === "string") {
        commit("SET_LANGUAGE", languages);
      } else {
        const language = supportedLanguages.find((sl) => languages.find((l) => (l.split(new RegExp(sl, "gi")).length - 1 > 0 ? sl : null)));
        commit("SET_LANGUAGE", language);
      }
      console.log(languages);
      // Set language for backend. Important for user messages
      new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/server/setLanguage",
            data: { language: languages },
            method: "POST"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    }
  },
  getter: {
    language: (state) => state.language
  }
};
